import React, { useState, useEffect, useRef } from 'react';
// import { useHistory, useLocation } from 'react-router-dom';
import Header from "../../../../Components/Header/Header";
import Badge from 'react-bootstrap/Badge';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faArrowLeft } from '@fortawesome/free-solid-svg-icons';
import { Container, Row, Col, Modal } from 'react-bootstrap';
import { faPlus, faXmark, faCircle, faPaperclip, faBolt, faEllipsis, faLink, faCircleCheck, faRetweet, faGear } from '@fortawesome/free-solid-svg-icons';
import Export from "../../../../assets/images/export.svg";
import View from "../../../../assets/images/view.svg";
import Trash from '../../../../assets/images/trash.png';
import { Tab, Tabs, Dropdown, Button } from 'react-bootstrap';

import Cargoplane from "../../../../assets/images/plane.svg";
import Cuser from "../../../../assets/images/cuser.png";
import { Link } from 'react-router-dom';
import ActivityComments from '../../../../Components/common/ActivityComments';
import ImageUpload from '../../../../Components/common/ImageUpload';
import { GETULDDETAILS, MVTHDETAILS } from '../../../../Utils/conts';
import { withRFSToken } from '../../../../Services/axios';
import Accordion from 'react-bootstrap/Accordion';
import LeftMenu from '../../../../Components/LeftMenu/LeftMenu';
import { toast } from 'react-toastify';
import ConfModal from '../../../../Components/common/ConfModal';

const MHDetails = () => {
  const queryParameters = new URLSearchParams(window.location.search);
  const Uldid = queryParameters.get("id");
  const detailsType = queryParameters.get("type");
  const backTab = queryParameters.get("tab");

  let storedData = localStorage.getItem('MHDetails');

  if (storedData) {
    storedData = JSON.parse(storedData)
  }
  const [operationDate, setOperationDate] = useState('');
  const [operationTime, setOperationTime] = useState('');

  const [gridData, setGridData] = useState([]);
  const [selectedRowData, setSelectedRowData] = useState(null);
  const [gridSelect, setGridSelect] = useState([]);

  const [disLoading, setDisLoading] = useState(false);
  const [modalConf, setModalConf] = useState(false);
  const [confData, setConfData] = useState({});
  const gridRef = useRef(null);

  useEffect(() => {
    const operationDateTime = storedData.Form.operation_date;
    if (operationDateTime) {
      const [opDate, opTime] = operationDateTime.split(' ');
      setOperationDate(opDate);
      setOperationTime(opTime);
    }
    setGridData(storedData.ULD)
  }, [])

  // const history = useHistory();
  // const location = useLocation();

  // if (Uldid){
  //     setUldNumber(Uldid);
  //     queryParameters.delete('uld_number');
  //     history.push({
  //         pathname: location.pathname,
  //       });
  //     window.location.replace('/ULDControl/MovementHistory')
  // }
  const [uldNumber, setUldNumber] = useState(Uldid);



  useEffect(() => {
    if (gridRef.current) {
      if (gridData) {
        // const localData = gridData[activeTab].map(item => ({

        //     id: item.id,
        //     STN: item.station_code,
        //     Taddrs: item.station_addresses.length,
        //     Address: item.station_addresses // ?.join(', ')Join the address array into a string
        // }));
        // console.log("🚀 ~ localData ~ localData:", localData)
        const source = {
          datatype: 'json',
          id: '',
          datafields: [
            { name: 'id', type: 'string' },
            { name: 'uld_number', type: 'string' },
            { name: 'type_code', type: 'string' },
            { name: 'serial_number', type: 'string' },
            { name: 'owner_code', type: 'string' },
            { name: 'content_code', type: 'string' },
            { name: 'luc_final_dest', type: 'string' },
            { name: 'awb_number', type: 'string' },
            { name: 'uld_id', type: 'string' },
          ],
          localdata: gridData,
        };

        const dataAdapter = new window.$.jqx.dataAdapter(source);
        // console.log('localdata', source.localdata)
        const columns = [
          {
            text: 'Action',
            cellsrenderer: function () {
              return '<div class="grid_actions"><img src="' + Trash + '" class="row_delete" /></div>';
            },
            width: '5%'
          },
          { text: 'ULD Number', filtertype: 'textbox', datafield: 'uld_number', width: '11%', cellclassname: '', },
          { text: 'Type Code', filtertype: 'textbox', datafield: 'type_code', width: '10%', cellclassname: '', },
          { text: 'Serial Number', filtertype: 'textbox', datafield: 'serial_number', width: '10%', cellclassname: '', },
          { text: 'Owner Code', filtertype: 'textbox', datafield: 'owner_code', width: '10%', cellclassname: '', },
          { text: 'Content Code', filtertype: 'textbox', datafield: 'content_code', width: '10%', cellclassname: '', },
          { text: 'Final Destination', filtertype: 'textbox', datafield: 'luc_final_dest', width: '10%', cellclassname: '', },
          { text: 'Airway Bill', filtertype: 'textbox', datafield: 'awb_number', width: '10%', cellclassname: '', },

        ];

        const gridOptions = {
          width: '100%',
          source: dataAdapter,
          columns: columns,
          autoheight: true,
          sortable: true,
          altrows: false,
          enabletooltips: true,
          editable: false,
          // selectionmode: 'checkbox',
          pageable: true,
          pageSize: 50,
          pagesizeoptions: ['50', '100', '200', '500'],
          pagerButtonsCount: 5,
          pagerMode: 'advanced',
          filterable: true,
          filterrowheight: 45,
          showfilterrow: true,
          rowsheight: 42,
          columnsheight: 45,

        };

        window.$(gridRef.current).jqxGrid(gridOptions);
        window.$(gridRef.current).find('.jqx-grid-column-header').css('background-color', 'white');

        window.$(gridRef.current).find('div[role="row"]').each((index, row) => {
          window.$(row).on('mouseover', () => {
            window.$(row).addClass('row-hover');
          });
          window.$(row).on('mouseout', () => {
            window.$(row).removeClass('row-hover');
          });
        });
        window.$(gridRef.current).off('cellclick');
        window.$(gridRef.current).on('cellclick', (event) => {
          const args = event.args.row.bounddata;
          if (event.args.columnindex > 0) {
            if (gridSelect) {
              gridSelect.forEach(item => {
                const selectedRowBoundIndex = item.boundindex;
                window.$(gridRef.current).jqxGrid('unselectrow', selectedRowBoundIndex);
              });
            }
            loadHistory(args.uld_number);
          }
        });
        window.$(gridRef.current).on('click', '.row_delete', function (row) {
          // console.log('ggggg');
          // const uldId = queryParameters.get("uld_number");

          const uldId = storedData.ULD.uld_number;

          const rowDiv = window.$(this).closest('[role="row"]');
          const rowIndex = window.$(rowDiv).attr('row-id');
          const rowData = window.$(gridRef.current).jqxGrid('getrowdata', rowIndex);
          console.log("🚀 ~ rowData:", rowData);
          // if (isMounted.current) return;
          setModalConf(true)
          setConfData(rowData)
          // isMounted.current = true;
        });

      } else {
        const columns = [
          { text: 'Stations', filtertype: 'textbox', datafield: 'STN', width: '50%' },
          { text: 'Total Address', filtertype: 'textbox', datafield: 'Taddrs', width: '50%' },
        ];
      }
    }
  }, [gridData, selectedRowData]);

  const [confModal, setConfModal] = useState(false)

  const handleUndo = async () => {

    try {
      const res = await withRFSToken.post('uld-action/undo-movement', { group_id: storedData.Form.group_id })
        .then(function (res) {
          if (res.data.response_code === 200) {
            toast.success(res.data.response_msg);
            loadHistory(storedData.Form.uld_number)
            // window.location.href = '/ULDControl/MovementHistory'
          }

        });
    } catch (error) {
      console.error('Error fetching data:', error);
    }
  }
  // upload forward
  const imageUploadRef = useRef(null);
  const browseClick = () => {
    if (imageUploadRef.current) {
      imageUploadRef.current.handleBrowseFiles();
    }
  };
  // end
  const loadHistory = async (uldNumber) => {
    try {
      const res = await withRFSToken.post(GETULDDETAILS, { uld_number: uldNumber })
        .then(function (res) {
          const innerData = res.data.response_data;
          console.log("🚀 ~ .then ~ innerData:654", innerData)
          // setSelectedRowData(innerData);
          localStorage.removeItem('MHistory');
          const storageData = {
            ULD: innerData,  // ULD Details section
            Form: {}  // Empty form section
          };
          localStorage.setItem('MHistory', JSON.stringify(storageData));
          localStorage.setItem('tab', 'assets');
          window.location.href = '/ULDControl/MovementHistory'

        });
    } catch (error) {
      console.error('Error fetching data:', error);
    }
  }
  const loadDetails = async (uldNumber) => {
    try {
      const res = await withRFSToken.post(GETULDDETAILS, { uld_number: uldNumber })
        .then(function (res) {
          const innerData = res.data.response_data;
          console.log("🚀 ~ .then ~ innerData:654", innerData)
          setSelectedRowData(innerData);
          let prevItem = localStorage.getItem('MHDetails');
          if (prevItem) {
            prevItem = JSON.parse(prevItem);
          }
          prevItem.Form = innerData;
          localStorage.setItem('MHDetails', JSON.stringify(prevItem));
          storedData = prevItem;
        });
    } catch (error) {
      console.error('Error fetching data:', error);
    }
  }

  const closeConfirm = () => {
    setModalConf(false)
  }
  const tabChangeConf = async () => {
    setDisLoading(true)
    try {
      console.log('confData', confData);
      
      const res = await withRFSToken.post('uld-action/undo-movement', { group_id: storedData.Form.group_id, uld_ids: [confData.uld_id]  })
        .then(function (res) {
          if (res.data.response_code === 200) {
            toast.success(res.data.response_msg);
            // loadDetails(confData.uld_number)
            loadHistory(confData.uld_number);
            // window.location.href = '/ULDControl/MovementHistory'
          } else {
            toast.error(res.data.response_msg);
            setDisLoading(false)
          }

        });
    } catch (error) {
      console.error('Error fetching data:', error);
    }
  }

  const handleDetailsClick = async () => {
          try {
              const res = await withRFSToken.post(MVTHDETAILS, { uld_id: storedData.Form.uld_id, uld_status_id: storedData.Form.uld_status_id, group_id: storedData.Form.group_id })
                  .then(function (res) {
                      const innerData = res.data.response_data;
                      // localStorage.removeItem('MHistory');
                      localStorage.removeItem('MHDetails');
                      // const storageData = {
                      //     ULD: selectedRowData,  // ULD Details section
                      //     Form: {}  // Empty form section
                      // };
                      // localStorage.setItem('MHistory', JSON.stringify(storageData));
                      const storageDataDetails = {
                          ULD: innerData.others_ulds,  // ULD Details section
                          Form: innerData.uld_movement_detail,
                          // tab: 'All'  // Empty form section
                      };
                      setGridData(innerData.others_ulds)
                      localStorage.setItem('MHDetails', JSON.stringify(storageDataDetails));
                      setDisLoading(false)
                  });
          } catch (error) {
              console.error('Error fetching data:', error);
              setDisLoading(false)
          }
      };
  // const loadHistory = async () => {
  //     try {
  //         const res = await withRFSToken.post(GETULDDETAILS, { uld_number: selectedRowData.uld_number })
  //             .then(function (res) {
  //                 const innerData = res.data.response_data;
  //                 console.log("🚀 ~ .then ~ innerData:654", innerData)
  //                 // setSelectedRowData(innerData);
  //                 localStorage.removeItem('MHistory');
  //                 const storageData = {
  //                     ULD: innerData,  // ULD Details section
  //                     Form: {}  // Empty form section
  //                 };
  //                 localStorage.setItem('MHistory', JSON.stringify(storageData));
  //                 localStorage.setItem('tab', 'assets');
  //                 window.location.href = '/ULDControl/MovementHistory'
  //                 setDisLoading(false)
  //             });
  //     } catch (error) {
  //         console.error('Error fetching data:', error);
  //     }
  // }
  const renderDetails = () => {


    let details = null;

    if (['UCM In', 'UCM Out'].includes(storedData.Form.operation_type)) {
      details = (
        <>
          <li><span>Truck/Flight :</span> {storedData.Form.flight_or_truck}</li>
          <li><span>Flight Number :</span> {storedData.Form.flight_number}</li>
          <li><span>Flight Date :</span> {storedData.Form.flight_date}</li>
          <li><span>Origin :</span> {storedData.Form.origin}</li>
          <li><span>Origin Handler Name:</span> {storedData.Form.origin_handler}</li>
          <li><span>Destination:</span> {storedData.Form.destination}</li>
          <li><span>Destination Handler Name:</span> {storedData.Form.destination_handler}</li>
          <li><span>Registration Number:</span> {storedData.Form.flight_reg_number}</li>
        </>
      );
    } else if (storedData.Form.operation_type === 'LUC Out') {
      details = (
        <>
          <li><span>Transfer Date:</span> {storedData.Form.operation_date}</li>
          <li><span>Control Receipt Number:</span> {storedData.Form.control_receipt_no}</li>
          <li><span>Transfer Point:</span> {storedData.Form.transfer_point}</li>
          <li><span>Transferred By:</span> {storedData.Form.transferred_by}</li>
          <li><span>Final Destination:</span> {storedData.Form.luc_final_dest}</li>
          <li><span>Received By:</span> {storedData.Form.received_by}</li>
        </>
      );
    } else if (storedData.Form.operation_type === 'LUC In') {
      details = (
        <>
          <li><span>Return Date:</span> {storedData.Form.operation_date}</li>
          <li><span>Control Receipt Number:</span> {storedData.Form.control_receipt_no}</li>
          <li><span>Return To:</span> {storedData.Form.return_to}</li>
          <li><span>Transfer Point:</span> {storedData.Form.transfer_point}</li>
          <li><span>Returned By:</span> {storedData.Form.returned_by}</li>
        </>
      );
    } else if (['Station Transfer', 'Transfer Request'].includes(storedData.Form.operation_type)) {
      details = (
        <>
          <li><span>Transfer Date:</span> {storedData.Form.operation_date}</li>
          <li><span>Control Receipt Number:</span> {storedData.Form.control_receipt_no}</li>
          <li><span>Transfer Point:</span> {storedData.Form.transfer_point}</li>
          <li><span>Transferred By:</span> {storedData.Form.transferred_by}</li>
          <li><span>Final Destination:</span> {storedData.Form.luc_final_dest}</li>
          <li><span>Received By:</span> {storedData.Form.received_by}</li>
        </>
      );
    } else if (['Repair In', 'Repair Out'].includes(storedData.Form.operation_type)) {
      details = (
        <>
          <li><span>Repair Name:</span> {storedData.Form.repair_name}</li>
          <li><span>Repair Station:</span> {storedData.Form.repair_station}</li>
          <li><span>Repair In:</span> {storedData.Form.operation_date}</li>
        </>
      );
    } else if (storedData.Form.operation_type === 'Lease Out') {
      details = (
        <>
          <li><span>Station Out:</span> {storedData.Form.destination}</li>
          <li><span>Remarks:</span> {storedData.Form.remarks}</li>
        </>
      );
    } else if (storedData.Form.operation_type === 'SCM') {
      details = (
        <>
          <li><span>Date of Check:</span> {storedData.Form.operation_date}</li>
          <li><span>Destination:</span> {storedData.Form.destination}</li>
          <li><span>Destination Handler Name:</span> {storedData.Form.destination_handler}</li>
        </>
      );
    }
    // Add more conditions as needed

    return details;
  };


  return (
    <>
      {disLoading &&
        <div className='mvt loader-container' style={{ top: '0', height: '1084px' }}><span className='mvt loader' style={{ left: 'calc(50% - 17px)', top: '40vh' }}></span></div>
      }
      {modalConf &&
        <ConfModal
          header={`Delete ${confData.uld_number} From Movement`}
          subHeader={`Are you sure you want to delete ULD ${confData.uld_number} from the movement? This action can not be undone.`}
          modalConf={tabChangeConf}
          closeModal={closeConfirm}
          primaryBtn='Delete'
          secondaryBtn='Cancel'
        />
      }
      <div className="">
        <Header logo_url='/ULDControl' />
        <div className="schedule">
          <LeftMenu />
          <div className='main-panel'>
            <Link to={'/ULDControl/MovementHistory'} className='stk_back'> <FontAwesomeIcon icon={faArrowLeft} /> Back</Link>
            <div className='maindiv'>

              <div className='SecondDiv mt-3'>
                {/* <button className='close' onClick={handleCloseClick}> <FontAwesomeIcon icon={faXmark} /> </button> */}
                <div className='girddtals_header'>
                  <h3>
                    {storedData.Form.operation_type}
                  </h3>
                  <div className='d-flex actbtn'>

                    <Button variant="light" onClick={browseClick} > <FontAwesomeIcon icon={faPaperclip} /> Attach</Button>
                    <Button variant="light" className='undo' onClick={() => setConfModal(true)} > <FontAwesomeIcon icon={faRetweet} /> Undo</Button>
                    {/* <Dropdown>
                    <Dropdown.Toggle variant="light" id="dropdown-basic">
                      <FontAwesomeIcon icon={faBolt} /> Actions <FontAwesomeIcon icon={faChevronDown} />
                    </Dropdown.Toggle>

                    <Dropdown.Menu>
                      <Dropdown.Item href="#/action-1">Edit Movement</Dropdown.Item>
                      <Dropdown.Item href="#/action-2">Delete Movement</Dropdown.Item>
                    </Dropdown.Menu>
                  </Dropdown> */}

                  </div>

                </div>
                <div className='d-flex justify-content-between rabord'>
                  <div className='firstbrd'>
                    <p>Origin</p>
                    <span>{storedData.Form.origin}</span>
                  </div>
                  <div className='middlebrd'>
                    <p>{operationDate} {operationTime}</p>
                    <p><img src={Cargoplane} /></p>
                    <p>{storedData.Form.flight_number}</p>
                  </div>
                  <div className='lastbrd'>
                    <p>Destination</p>
                    <span>{storedData.Form.destination}</span>
                  </div>
                </div>

                <div className='opttrauck'>
                  <Accordion defaultActiveKey="0">
                    <Accordion.Item eventKey="0">
                      <Accordion.Header>Movement Information</Accordion.Header>
                      <Accordion.Body>
                        <ul className='mov_info'>
                          {renderDetails()}
                        </ul>

                      </Accordion.Body>
                    </Accordion.Item>

                  </Accordion>
                </div>

                <ImageUpload
                  ref={imageUploadRef}
                  attachable_type={"uld"}
                  attachable_id={storedData.Form.uld_number}
                  attachments={storedData.Form.attachments}
                  group_id={storedData.Form.group_id}
                // onupdate={() => loadAttachments()}
                />
                <ActivityComments
                  commentable_type={"uld"}
                  commentable_id={storedData.Form.uld_number}
                  allactivities={storedData.Form.activities}
                  onReloadDetails={loadDetails}
                />
              </div>
              <div className='trashdonload mt-3'>
                <div ref={gridRef} className='bookinggrid' ></div>
              </div>

            </div>

          </div>
        </div>
        <Modal show={confModal} onHide={() => setConfModal(false)} className='addfrom change_type' centered>
          <Modal.Header closeButton>
          </Modal.Header>
          <Modal.Body>
            <h3>Undo Movement Confirmation</h3>
            <p>Are you sure you want to undo this movement? This action will permanently delete the movement from the system.</p>
          </Modal.Body>
          <Modal.Footer>
            <div className='d-flex w-50 mx-auto are_bottom'>
              <Button variant="secondary" onClick={() => setConfModal(false)}>
                No
              </Button>
              <Button variant="primary" onClick={handleUndo}>
                Yes
              </Button>
            </div>
          </Modal.Footer>
        </Modal>
      </div>
    </>
  )
}

export default MHDetails;